import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ChevronRight } from "lucide-react";

export default function PageHero({ overline, title, subtitle, crumbs = [] }) {
  return (
    <section className="relative overflow-hidden border-b border-white/10 pt-36 pb-16 lg:pt-44 lg:pb-20" data-testid="page-hero">
      <div className="absolute inset-0 grid-bg radial-fade opacity-60" />
      <div className="pointer-events-none absolute left-1/2 top-0 h-72 w-[700px] -translate-x-1/2 rounded-full bg-vantage/15 blur-[130px]" />
      <div className="container-wv relative">
        <nav className="mb-6 flex items-center gap-2 text-sm text-slate-500" aria-label="Breadcrumb">
          <Link to="/" className="hover:text-white">Home</Link>
          {crumbs.map((c, i) => (
            <span key={i} className="flex items-center gap-2">
              <ChevronRight className="h-4 w-4" />
              {c.to ? <Link to={c.to} className="hover:text-white">{c.label}</Link> : <span className="text-slate-300">{c.label}</span>}
            </span>
          ))}
        </nav>
        {overline && <span className="overline">{overline}</span>}
        <motion.h1
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          className="mt-4 max-w-4xl font-heading text-4xl font-bold tracking-tighter text-white sm:text-5xl lg:text-6xl"
        >
          {title}
        </motion.h1>
        {subtitle && (
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.15 }}
            className="mt-6 max-w-2xl text-base leading-relaxed text-slate-400 sm:text-lg"
          >
            {subtitle}
          </motion.p>
        )}
      </div>
    </section>
  );
}
